import { HISTORICAL, PROJECTED } from 'common/constants/financials';
import { MIN_DRAWER_HEIGHT } from 'components/Drawer/draggable-drawer/DraggableDrawer.constants';
import { FloatingButtonGroup } from 'components/FloatingButtonGroup';
import { FinancialsButtonsProps } from './FinancialsButtons.props';

const FinancialsButtons = ({ addFinancialYear, isDisabled }: FinancialsButtonsProps) => (
  <FloatingButtonGroup
    style={{ marginBottom: MIN_DRAWER_HEIGHT }}
    id="financials-add-historical-year-btn"
    disabled={isDisabled}
    mainAction={{
      key: 'fund-ownership-add-btn',
      label: PROJECTED,
      onClick: () =>
        addFinancialYear({
          isPrevYear: false,
        }),
    }}
    secondaryActions={[
      {
        key: 1,
        label: HISTORICAL,
        onClick: () =>
          addFinancialYear({
            isPrevYear: true,
          }),
      },
    ]}
  />
);

export default FinancialsButtons;
